import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {runAfterLoadSession} from "../../utils/Utility";
import Talk from 'talkjs';
import {history} from "../../history/History";

import HeaderApp from "./HeaderApp";
import {checkChat} from "../../utils/API";

class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: 'Loading chat...',
        }

        this.inbox = undefined
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            if (!this.props.match.params.me || !this.props.match.params.other || !this.props.talkAppId) {
                history.push("/hom")
                return
            }
            checkChat(this.props.match.params.me, this.props.match.params.other, (res) => {
                Talk.ready.then(() => {
                    console.log(res)
                    const me = new Talk.User({
                        id: res.me.hashId,
                        name: res.me.username,
                        email: res.me.email,
                        photoUrl: window.baseFile + res.me.profilePhotoUrl,
                        welcomeMessage: "Hello",
                        role: "default"
                    });

                    if (!window.talkSession) {
                        window.talkSession = new Talk.Session({
                            appId: this.props.talkAppId,
                            me: me
                        });
                    }

                    const other = new Talk.User({
                        id: res.other.hashId,
                        name: res.other.username,
                        email: res.other.email,
                        photoUrl: window.baseFile + res.other.profilePhotoUrl,
                        welcomeMessage: "Hello",
                        role: "default"
                    });
                    const conversationId = Talk.oneOnOneId(me, other);

                    const conversation = window.talkSession.getOrCreateConversation(conversationId);
                    conversation.setParticipant(me);
                    conversation.setParticipant(other);

                    this.inbox = window.talkSession.createInbox({
                        selected: conversation
                    });
                    this.inbox.mount(this.container);

                })
                    .catch(e => {
                        this.setState({msg: 'There was an error loading the chat'})
                    });
            }, () => {
                this.setState({msg: 'There was an error loading the chat'})
            })
        })

    }

    render() {
        return (
            <div className="">
                <HeaderApp name="chat" back="/hom"/>
                <div className="main-app  back-grey">
                    <div className="text-center" style={{height: '600px'}} ref={c => this.container = c}>
                        <h4>
                            {this.state.msg}
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        token: state.param[Objects.token],
        tutorEnv: state.param[Objects.tutorEnv],
        talkAppId: state.param[Objects.talkAppId],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat)
